import type { ColumnFilter } from "@tanstack/react-table";
import type { TFunction } from "i18next";

import { Button, Confirm } from "src/components";
import type { CustomerListDto } from "src/types";

export const createActionsForSelection =
    (t: TFunction, blockPayersMutation: (value: Array<number>) => void) =>
    (_: boolean, selectedRows: CustomerListDto[], __: ColumnFilter[]) => {
        const selectedRowIds = selectedRows.map((row) => row.id);
        const onClick = () => {
            blockPayersMutation(selectedRowIds);
        };
        return (
            <Confirm
                title={t("customers.deactivate.confirm.title")}
                content={t("customers.deactivate.confirm.content")}
                onConfirm={onClick}
            >
                {(open) => (
                    <Button disabled={selectedRows.length === 0} type="button" onClick={open}>
                        {t("customers.deactivate.deactivateSelected")}
                    </Button>
                )}
            </Confirm>
        );
    };
